(() => {
  if (window.YamuriMediaVideoLoaded) return;
  window.YamuriMediaVideoLoaded = true;
  const selector = '[data-yamuri-video]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const sendPause = (frame, type) => {
    if (!frame.contentWindow) return;
    const message = type === 'youtube'
      ? JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] })
      : { method: 'pause' };
    frame.contentWindow.postMessage(message, '*');
  };

  const loadFrame = (frame, allowAutoplay) => {
    if (!frame || frame.hasAttribute('src') || !frame.dataset.src) return;
    let source = frame.dataset.src;
    if (!allowAutoplay) {
      source = source.replace('autoplay=1', 'autoplay=0').replace('controls=0', 'controls=1');
    }
    frame.src = source;
  };

  const setup = (root = document) => {
    root.querySelectorAll(selector).forEach((container) => {
      if (container.dataset.videoReady === 'true') return;
      container.dataset.videoReady = 'true';
      const nativeVideo = container.querySelector('video');
      const frame = container.querySelector('iframe[data-src]');
      const wantsAutoplay = container.dataset.autoplay === 'true';

      if (nativeVideo && reducedMotion.matches) nativeVideo.controls = true;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const allowAutoplay = wantsAutoplay && !reducedMotion.matches;
          if (entry.isIntersecting) {
            loadFrame(frame, allowAutoplay);
            if (nativeVideo && allowAutoplay) nativeVideo.play().catch(() => {});
          } else {
            if (nativeVideo && !nativeVideo.paused) nativeVideo.pause();
            if (frame && frame.hasAttribute('src')) sendPause(frame, container.dataset.videoType);
          }
        });
      }, { rootMargin: '300px 0px', threshold: 0.15 });
      observer.observe(container);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
